export default __webpack_public_path__ + "static/media/default.902d11ef.svg";